import { ApplicationController } from "../../application_controller"
import Rails from '@rails/ujs'

export default class extends ApplicationController {

    initialize() {}

    connect() {
	var subscriptionAddressBtn = this.element.querySelector('.subscription-billing .subscription-address-btn')
	if (subscriptionAddressBtn && subscriptionAddressBtn.classList.contains('chosen')) {
	    var addressIdChosen = subscriptionAddressBtn.dataset.addressIdChosen
	    var singleAddressElement = subscriptionAddressBtn.closest('.address-info').querySelector(`.address-chooser .single-address.address-${addressIdChosen}`)
	    if (singleAddressElement) {
		subscriptionAddressBtn.querySelector('span').innerHTML = this.cleanHTMLToSingleLine(singleAddressElement.querySelector('.address-showcase'))
	    }
	}
    }

    cardValidate(event) {
	var cardNetworks = { Visa: /^4/, MasterCard: /^(5[1-5]|2[2-7])/, Amex: /^3[47]/, RuPay: /^(60|65|81|82)/ }

	var cardFieldsElement = event.currentTarget.closest(".card-fields")
	var cardNkElement = cardFieldsElement.querySelector(".card-nk")
	var cardNoElement = cardFieldsElement.querySelector(".card-no")
	var cardMnElement = cardFieldsElement.querySelector(".card-mn")
	var cardYrElement = cardFieldsElement.querySelector(".card-yr")
	var cardCvElement = cardFieldsElement.querySelector(".card-cv")

	var cardNo = cardNoElement.value.replace(/\D/g, "")
	var cardNetwork = null

	// Card Network
	for (const [network, regex] of Object.entries(cardNetworks)) {
	    if (regex.test(cardNo)) { cardNetwork = network }
	}
	cardNkElement.querySelectorAll('img[class*="nk-"]').forEach(el => el.classList.remove('active'))
	cardNetwork ? cardNkElement.querySelector(`img.nk-${cardNetwork.toLowerCase()}`).classList.add('active') : cardNkElement.querySelector('img.nk-card').classList.add('active')

	// Card Number
	var cardNoWithFormat = null
	if (cardNetwork === "Amex") {
	    // 4-6-5 format
	    cardNoWithFormat = cardNo.replace(/^(\d{0,4})(\d{0,6})(\d{0,5}).*/, (_, g1, g2, g3) => { return [g1, g2, g3].filter(Boolean).join(" ") })
	} else if (cardNetwork === "Visa" || cardNetwork === "MasterCard" || cardNetwork === "RuPay") {
	    // 4-4-4-4 format
	    cardNoWithFormat = cardNo.replace(/(\d{4})(?=\d)/g, "$1 ").trim()
	} else {
	    cardNoWithFormat = cardNo
	}
	cardNoElement.value = cardNoWithFormat

	// Card Month
	cardMnElement.value = cardMnElement.value.replace(/\D/g, "")

	// Card Year
	cardYrElement.value = cardYrElement.value.replace(/\D/g, "")

	// CVV
	cardCvElement.value = cardCvElement.value.replace(/\D/g, "")
	cardCvElement.value = cardCvElement.value.slice(0, (cardNetwork === "Amex" ? 4 : 3))

	// Go to next input
	if (cardNoElement.matches(":focus")) {
	} else if (cardMnElement.matches(":focus")) {
	    if (cardMnElement.value.length == 2) { cardYrElement.focus() }
	} else if (cardYrElement.matches(":focus")) {
	    if (cardYrElement.value.length == 2) { cardCvElement.focus() }
	} else if (cardCvElement.matches(":focus")) {
	}
    }

    cardKeydown(event) {
	var cardFieldsElement = event.currentTarget.closest(".card-fields")
	var cardNkElement = cardFieldsElement.querySelector(".card-nk")
	var cardNoElement = cardFieldsElement.querySelector(".card-no")
	var cardMnElement = cardFieldsElement.querySelector(".card-mn")
	var cardYrElement = cardFieldsElement.querySelector(".card-yr")
	var cardCvElement = cardFieldsElement.querySelector(".card-cv")

	// Handle backspace
	if (cardNoElement.matches(":focus")) {
	} else if (cardMnElement.matches(":focus")) {
	} else if (cardYrElement.matches(":focus")) {
	    if (event.key === "Backspace" && event.target.value === "") { cardMnElement.focus() }
	} else if (cardCvElement.matches(":focus")) {
	    if (event.key === "Backspace" && event.target.value === "") { cardYrElement.focus() }
	}
    }

    toggleAddressChooser(event) {
	event.preventDefault()

	if (event.currentTarget.closest('.add-single-subscription').classList.contains('summary-open')) {
	    return
	}

	var addressChooserElement = event.currentTarget.closest('.address-info').querySelector('.address-chooser')
	
	if (addressChooserElement.classList.contains('active')) {
	    $(addressChooserElement).animateCss('slideOutUp', () => {
		addressChooserElement.classList.remove('active')
	    })
	} else {
	    addressChooserElement.classList.add('active')
	    $(addressChooserElement).animateCss('slideInDown')
	    if (addressChooserElement.children.length === 1 && addressChooserElement.querySelector('.single-address.new-address')) {
		if (!addressChooserElement.querySelector('.single-address.new-address.edit-mode')) {
		    var newAddressBtnElement = addressChooserElement.querySelector('.single-address.new-address .address-btn.new-address-btn')
		    if (newAddressBtnElement) { newAddressBtnElement.click() }
		}
	    }
	}
    }

    addressChosen(event) {
	if(event.currentTarget.classList.contains('edit-mode')) {
	    return
	}

	var subscriptionAddressBtn = event.currentTarget.closest('.address-info').querySelector('.subscription-address-btn')
	subscriptionAddressBtn.setAttribute('data-address-id-chosen', event.currentTarget.querySelector('a.address-btn').dataset.addressId)
	subscriptionAddressBtn.querySelector('span').innerHTML = this.cleanHTMLToSingleLine(event.currentTarget.closest('.single-address').querySelector('.address-showcase'))
	subscriptionAddressBtn.classList.add('chosen')

	var addressChooserElement = event.currentTarget.closest('.address-info').querySelector('.address-chooser')
	$(addressChooserElement).animateCss('slideOutUp', () => {
	    addressChooserElement.classList.remove('active')
	})
    }

    openSummary(event) {
	event.preventDefault()

	var addSubscriptionElement = event.currentTarget.closest('.add-single-subscription')
	if (addSubscriptionElement) {
	    var variety_id_chosen = addSubscriptionElement.querySelector('.subscription-chooser form input[name="operations_subscription[variety_id_chosen]"]:checked').value
	    //var card_no = addSubscriptionElement.querySelector('.subscription-billing .card-info .card-fields input.card-no').value
	    //var card_mn = addSubscriptionElement.querySelector('.subscription-billing .card-info .card-fields input.card-mn').value
	    //var card_yr = addSubscriptionElement.querySelector('.subscription-billing .card-info .card-fields input.card-yr').value
	    //var card_cv = addSubscriptionElement.querySelector('.subscription-billing .card-info .card-fields input.card-cv').value
	    var person_name = addSubscriptionElement.querySelector('.subscription-billing form .person-info input[name="operations_subscription[person_name]"]').value
	    var person_company_name = addSubscriptionElement.querySelector('.subscription-billing form .person-info input[name="operations_subscription[person_company_name]"]').value
	    var person_phone = addSubscriptionElement.querySelector('.subscription-billing form .person-info input[name="operations_subscription[person_phone]"]').value
	    var address_id_chosen = addSubscriptionElement.querySelector('.subscription-billing .address-info .subscription-address-btn').dataset.addressIdChosen

	    addSubscriptionElement.querySelectorAll('.subscription-billing .subscription-guidance span').forEach(el => { el.classList.remove('active') })
	    if (!this.hasValue(variety_id_chosen)) {
		return
	    }
	    //if (!this.hasValue(card_no) || !this.hasValue(card_mn) || !this.hasValue(card_yr) || !this.hasValue(card_cv)) {
	    //	this.showGuidance(addSubscriptionElement.querySelector('.subscription-billing .subscription-guidance span.missing-card'))
	    //	return
	    //}
	    if (!this.hasValue(person_name)) {
		this.showGuidance(addSubscriptionElement.querySelector('.subscription-billing .subscription-guidance span.missing-billing-name'))
		return
	    }
	    if (!this.hasValue(person_phone)) {
		this.showGuidance(addSubscriptionElement.querySelector('.subscription-billing .subscription-guidance span.missing-billing-phone'))
		return
	    }
	    if (!this.hasValue(address_id_chosen)) {
		this.showGuidance(addSubscriptionElement.querySelector('.subscription-billing .subscription-guidance span.missing-billing-address'))
		return
	    }

	    var subscriptionDetailsForm = addSubscriptionElement.querySelector('.subscription-summary form.subscription-details-form')
	    subscriptionDetailsForm.querySelector('input[name="operations_subscription[variety_id_chosen]"]').value = variety_id_chosen
	    subscriptionDetailsForm.querySelector('input[name="operations_subscription[person_name]"]').value = person_name
	    subscriptionDetailsForm.querySelector('input[name="operations_subscription[person_company_name]"]').value = person_company_name
	    subscriptionDetailsForm.querySelector('input[name="operations_subscription[person_phone]"]').value = person_phone
	    subscriptionDetailsForm.querySelector('input[name="operations_subscription[address_id_chosen]"]').value = address_id_chosen

	    Rails.fire(subscriptionDetailsForm, "submit")
	}
    }

    closeSummary(event) {
	// no action if summary is not open.
	if (!event.currentTarget.closest('.add-single-subscription').classList.contains('summary-open')) { return }

	var subscriptionBillingElement = event.currentTarget.closest('.add-single-subscription').querySelector('.subscription-billing')
	$(subscriptionBillingElement.closest('.scroll-wrapper').querySelector('.subscription-summary')).animateCss('slideOutDown', () => {
	    subscriptionBillingElement.closest('.add-single-subscription').classList.remove('summary-open')
	})
    }

    thankyouButton(event) {
	event.preventDefault()

	const href = event.currentTarget.getAttribute('href')
	if(href == "#") {
	    window.location.reload(true)
	} else {
	    window.location.href = href
	}
    }

    beforeSubmitDetails(event) {
	this.profilesController.showLoader()
    }

    cleanHTMLToSingleLine(container) {
	return container.innerHTML.replace(/<br\s*\/?>/gi, '  ').replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim()
    }

    hasValue(value) {
	return value != null && value !== ''
    }

    showGuidance(el) {
	clearTimeout(this.guidanceTimeoutId)

    	el.classList.add('active')
	$(el).animateCss('slideInUp', () => {
	    this.guidanceTimeoutId = setTimeout(() => {
		$(el).animateCss('slideOutDown', () => {
		    el.classList.remove('active')
		})
	    }, 2000)
	})
    }

    get profilesController() {
	return this.application.getControllerForElementAndIdentifier(document.querySelector('[data-controller="marketing--profiles"]'), "marketing--profiles")
    }
}
